import React from 'react';

import Home from './Home';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Reservation from './pages/reservation/Reservation';
import Cars from './pages/cars/cars';


import Footer from './components/footer/Footer';
import Nissanmicra from './pages/cars/carpages/NissanMicra/NissanMicra';
import Toyotayarus from './pages/cars/carpages/ToyotaYarus/ToyotaYarus';
import Ravfore from './pages/cars/carpages/ToyotaRavfore/Ravfore';

import RenaultDaster from './pages/cars/carpages/RenaultDaster/RenaultDaster';
import RenaultLogan from './pages/cars/carpages/RenaultLogan/RenaultLogan';
import RenaultSandero from './pages/cars/carpages/RenaultSandero/RenaultSandero';
import ToyotaCorolla from './pages/cars/carpages/ToyotaCorolla/ToyotaCorolla';
import ToyotaFortuner from './pages/cars/carpages/ToyotaFortuner/ToyotaFortuner';
import ToyotaPrado from './pages/cars/carpages/ToyotaPrado/ToyotaPrado';
import NewsOne from './pages/News/One/NewsOne';
import NewsTwo from './pages/News/Two/NewsTwo';
import NewsThree from './pages/News/Three/NewsThree';
import About from './pages/footer/About/About';
import HyundaiTucson from './pages/cars/carpages/HyundaiTucson/HyundaiTucson';
import HyundaiCreta from './pages/cars/carpages/HyundaiCreta/HyundaiCreta';
import Contact from './pages/footer/contact/Contact';


import SearchResults from './components/hero/SearchResults';
import Satesto from './test/test';
import CarPage from './test/CarPage';
function App() {
  return (
    <>
    
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/reservation' element={<Reservation />}></Route> 
        <Route path='/cars' element={<Cars />}></Route>
       
        <Route path='/nissan_micra' element={<Nissanmicra />}></Route>
        <Route path='/toyoya_yarus' element={<Toyotayarus/>}></Route>
        <Route path='/Hyundai_Tucson' element={<HyundaiTucson/>}></Route>
        <Route path='/Renault_daster' element={<RenaultDaster/>}></Route>
        <Route path='/Renault_Logan' element={<RenaultLogan/>}></Route>
        <Route path='/Renault_Sandero' element={<RenaultSandero/>}></Route>
        <Route path='/Toyota_Corolla' element={<ToyotaCorolla/>}></Route>
        <Route path='/Toyota_Fortuner' element={<ToyotaFortuner/>}></Route>
        <Route path='/Toyota_Prado' element={<ToyotaPrado/>}></Route>
        <Route path='/newsone' element={<NewsOne/>}></Route>
        <Route path='/newstwo' element={<NewsTwo/>}></Route>
        <Route path='/newsthree' element={<NewsThree/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/Rav_fore' element={<Ravfore />}></Route>
        <Route path='/Hyundai_Creta' element={<HyundaiCreta/>}></Route>



        <Route path="/search-results" element={<SearchResults/ >}></Route>
        <Route path='/Satesto' element={<Satesto/>}></Route>
        <Route path='/CarPage' element={<CarPage/>}></Route>
      
        

      </Routes>
      <Footer /> 
      
    </>

  );
}

export default App;
